import { render, staticRenderFns } from "./ForecastReportArea.vue?vue&type=template&id=090d57d8&scoped=true"
import script from "./ForecastReportArea.vue?vue&type=script&lang=js"
export * from "./ForecastReportArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d57d8",
  null
  
)

export default component.exports